var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('Loading')],1):_vm._e(),(!_vm.loading)?_c('div',[(_vm.isDriver)?_c('Disposals',{attrs:{"bookings":_vm.getDriverDisposals}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }